import React, { useContext, useEffect, useState } from "react";
import "./shedule.scss";
import ShowStep from "../../atoms/show-step/showStep";
import SectionSpecialist from "../section-specialist/sectionSpecialist";
import CategoryOrganism from "../category-organism/categoryOrganism";
import SectionSchedule from "../section-schedule/sectionSchedule";
import SectionSummary from "../section-summary/sectionSummary";
import SectionConfirmation from "../section-confirmation/sectionConfirmation";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import GlobalContext from "../../../contexts/globalContext";
import {
  getAllCategories,
  getAllResources,
} from "../../../services/scheduling";
import LoadingPage from "../../atoms/loading-page/loading-page";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
const Shedule = (props: ReferenciaContenido) => {
  const [pageAtive, setpageAtive] = useState(1);
  const [nextPage, setnextPage] = useState("Categorias");
  const [selectCategory, setselectCategory] = useState([]);
  const [selectSpecialist, setselectSpecialist] = useState([]);
  const [nameCategory, setnameCategory] = useState("");
  const COMPANYID = "5efc770970dc6f1254c2c0a1";
  const [confirmationDate, setconfirmationDate] = useState({});
  const [repro, setrepro] = useState(false);
  const [loading, setloading] = useState(false);
  const [respuesta, setRespuesta] = useState();
  const globalContext = useContext(GlobalContext);
  const reprograming = async () => {
    setloading(true);
    const eventD: any = sessionStorage.getItem("EventData");
    const token: any = globalContext.userInfoContext.data?.userJwt;
    const { window } = useBrowserMode();
    const rep = window.location.hash;
    const repData = JSON.parse(eventD);
    let allServices: any = [];

    if (rep && repData) {
      setloading(true);
      setpageAtive(6);
      const data = await getAllCategories(
        globalContext.userInfoContext.data?.userJwt
      );

      if (data.data.data.transServiceList !== null)
        allServices = data.data.data.transServiceList;
      sessionStorage.setItem(
        "Token",
        JSON.stringify({
          accessToken: data.data.accessToken,
          companyId: COMPANYID,
        })
      );
      const services = allServices.find((el) => el.id === repData.serviceId);
      setselectCategory(services);
      const specialist = await getAllResources(
        token,
        services.resourcesIds,
        services.id
      );
      const spec = specialist.data.data.body.data.find(
        (el) => el.id === repData.resourceId
      );
      setselectSpecialist(spec);
      setnameCategory(repData.serviceName);
      setrepro(true);
      setpageAtive(3);
      setloading(false);
    }
    setloading(false);
  };

  useEffect(() => {
    reprograming();
  }, []);
  return (
    <>
      <ShowStep pageActual={pageAtive} nextPage={nextPage} />
      {loading && <LoadingPage />}
      {pageAtive === 1 && (
        <CategoryOrganism
          setpageAtive={setpageAtive}
          setselectCategory={setselectCategory}
          setnameCategory={setnameCategory}
          COMPANYID={COMPANYID}
          content={props.referenciaPlantillaContenido[0]}
          afterPage={props.referenciaPlantillaContenido[1].tituloBanner}
        />
      )}
      {pageAtive === 2 && (
        <SectionSpecialist
          setpageAtive={setpageAtive}
          setnextPage={setnextPage}
          nameCategory={nameCategory}
          selectCategory={selectCategory}
          setselectSpecialist={setselectSpecialist}
          content={props.referenciaPlantillaContenido[1]}
          afterPage={props.referenciaPlantillaContenido[2].tituloBanner}
          beforePage={"Servicios"}
        />
      )}
      {pageAtive === 3 && (
        <SectionSchedule
          setpageAtive={setpageAtive}
          setnextPage={setnextPage}
          selectCategory={selectCategory}
          selectSpecialist={selectSpecialist}
          pageAtive={pageAtive}
          setselectSpecialist={setselectSpecialist}
          content={props.referenciaPlantillaContenido[2]}
          beforePage={props.referenciaPlantillaContenido[1].tituloBanner}
          setconfirmationDate={setconfirmationDate}
          nameCategory={nameCategory}
        />
      )}
      {pageAtive === 4 && (
        <SectionSummary
          setpageActive={setpageAtive}
          setnextPage={setnextPage}
          confirmationDate={confirmationDate}
          selectSpecialist={selectSpecialist}
          repro={repro}
          repData={JSON.parse(sessionStorage.getItem("EventData"))}
          COMPANYID={COMPANYID}
          content={props.referenciaPlantillaContenido[3]}
          setResp={setRespuesta}
          respuesta={respuesta}
        />
      )}
      {pageAtive === 5 && (
        <SectionConfirmation
          setnextPage={setnextPage}
          content={props.referenciaPlantillaContenido[4]}
          confirmationDate={confirmationDate}
          reprogramming={repro}
          resp={respuesta}
        />
      )}
    </>
  );
};

export default Shedule;
